<template>
  <div class="w-100">
    <div>
      <label class="pb-2 fw-bold opacity-80" for="">{{ $t('presenter-search') }}</label>
      <p>{{ $t('enter-at-least-three-characters-to-start-your-search-adding-more-details-will-increase-search-accuracy') }}</p>

      <div class="form-group">
        <input id="search_presenter_query" v-model="searchPresenterQuery" data-test="search_presenter_query" type="search"
        class="form-control custom-control rounded-0 border-2 border-primary" :placeholder="$t('search-presenter')">
        <span v-if="searchPresenterQuery.length" role="button" class="close float-end fs-4"
        style="margin-top: -2.35rem !important; margin-right: 0.7rem !important;" @click.prevent="searchPresenterQuery = ''">
          <span aria-hidden="true"><i class="fa fa-times"></i></span>
        </span>
      </div>

      <PresenterSearch
        :network_media_id="media_id"
        :searchPresenterQuery="searchPresenterQuery"
        :searched_presenters="searched_presenters"
        :loading="loading"
        :limit="20"
        @add-media-presenter="newPresenterAddedToMedia"
        @remove-media-presenter="removeMediaPresenter"
      />
    </div>

    <div v-if="msg != ''" :class="msg_style" class="alert rounded-0 py-1 my-2 fw-bold" :style="{display: msg_display}">{{ msg }}</div>

    <label v-if="!searchedUserExists" class="pt-3 fw-bold small" for="">
    <span class="text-danger">Oops!</span> <span class="text-info">{{ $t('it-seems-like-following-presenter-is-not-registered-with-us-add-them-by-clicking-the-button-below-to-make-their-media-accessible-to-other-users') }}</span>
    </label>

    <InviteList
      :users="media_users" 
      @remove-media-user="removeMediaPresenter"
      @show-add-user-as-presenter-modal="m => (this.userModal = m)" />

    <label class="pt-3  fw-bold opacity-80" for="">
      <span v-if="media_presenters.length == 1">{{ $t('this-media-has-1-presenter') }}</span>
      <span v-else>{{ $t('this-media-has-presenters', { num: media_presenters.length }) }}</span>
    </label>
    <ExistingList
      :network_media_id="media_id"
      :presenters="media_presenters"
      @remove-media-presenter="removeMediaPresenter"
      @show-user-edit-modal="modal => (userModal = modal)"
      @show-presenter-edit-modal="modal => (presenterModal = modal)"
    />

    <b-modal v-model="presenterModal.showInviteModal" :title="presenterModal.title" size="lg" hide-footer>
      <PresenterForm
        :form="presenterModal.presenterForm"
        :invitation="presenterModal.invitationName"
        @presenter-invitation-update="presenterModalSubmitEvent"
      />
    </b-modal>

    <b-modal v-model="userModal.showInviteModal" :title="userModal.title" size="xl" hide-footer>
      <UserForm :form="userModal.userForm" :fields="userFormFields" :inInviteMode="userModal.inInviteMode" :submitText="userModal.submitText" @user-form-submit="userModalSubmitEvent" />
    </b-modal>
  </div>
</template>
<script>
import ExistingList from './ExistingPresenters.vue';
import InviteList from './InvitePresenters.vue';
import PresenterForm from '@/components/forms/profile/PresenterForm.vue';
import PresenterSearch from './PresenterSearch.vue';
import UserForm from '@/components/forms/profile/UserForm.vue';
import { debounce, find } from 'lodash';

export default {
  components: {
    ExistingList,
    InviteList,
    PresenterForm,
    PresenterSearch,
    UserForm,
  },
  props: {
    existingPresenters: {
      type: Array,
      default: null,
    },
    media_id: {
      type: [String, Number],
      default: null,
    },
    currentNetworkSlug: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: false,
      presenterModal: { presenterForm: null, showInviteModal: false, invitationName: '', title: '' },
      userModal: { userForm: null, showInviteModal: false, invitationName: '', title: '', inInviteMode: false, submitText: '' },
      media_presenters: [], // Transformed presenters list used by tag-input-field
      searched_presenters: [], // Transformed presenters list used by tag-input-field
      media_users: [], // Transformed presenters list used by tag-input-field
      searchPresenterQuery : '',
      msg : '',
      msg_style : '',
      msg_display : 'none',
      searchedUserExists : true,
      userFormFields: {
        name_prefix: true,
        first_name: true,
        last_name: true,
        email: true,
        name_suffix: true,
        phone_number: true,
        address: true,
        city: true,
        country: true,
      },
    };
  },
  watch: {
    searchPresenterQuery: debounce(function(value) {
      this.searchPresenters(value);
      this.msg = '';
    },600),
  },
  mounted(){
    // get media presenters
    this.loadMediaPresenters();
  },
  methods: {
    newPresenterAddedToMedia(searchedValue) {
      this.media_users = [];
      if(!searchedValue.user_id){
        let presenter = {
          text : this.searchPresenterQuery
        };
        console.log(presenter,'presenter');
        (!find(this.media_users,['text',presenter.text])) ? this.media_users.push(presenter) : '';
          this.searchPresenterQuery = '';
      } else {
        let presenter = searchedValue;
        this.axios
        .post('media/presenter/add', { presenter : presenter, media_id : this.media_id })
        .then( () => {
          this.searchPresenterQuery = '';
          this.loadMediaPresenters();
          /*this.msg = "Presenter Added Successfully";
          this.msg_style = 'alert-success';
          this.msg_display = 'block';
          setTimeout(this.removePresenterAlert, 2000);*/
        })
        .catch(err => {
          console.log('err=', err);
          // this.$router.push('/networks'); // back to the homepage
        });
      }
   },
    updatePresenterList(updatedData, id, name) {
      let temp = Array.from(this.media_presenters);
      let updatedPresenterIndex = temp.findIndex(p => p.presenter_id == id || p.text == name);
      temp.splice(updatedPresenterIndex, 1, updatedData);
      this.axios.post('presenters/update-profile', temp);
      this.loadMediaPresenters();
    },
    // Object Transformers
    getPresenterObjectFromPresenterModel(p) {
      if (!p.id) return { text: p.name };
      return {
        presenter_id: p.id,
        user_id: p.user.user_id,
        text: p.user.first_name + ' ' + p.user.last_name,
        email: p.user.email,
        short_bio: p.short_bio,
        appointment: p.primary_appointment || null,
        is_registered: p.user.is_registered,
        userModel: p.user,
        presenterModel: p,
      };
    },
    getPresenterObjectFromUserModel(user) {
      return {
        user_id: user.user_id,
        text: user.first_name + ' ' + user.last_name,
        is_registered: user.is_registered,
        email: user.email,
        presenter_id: user.presenter ? user.presenter.id : undefined,
        short_bio: user.presenter ? user.presenter.short_bio : undefined,
        appointment: user.presenter ? user.presenter.primary_appointment || null : undefined,
        userModel: user,
        presenterModel: user.presenter,
      };
    },
    // MODAL EVENTS
    presenterModalSubmitEvent(data) {
      this.presenterModal.showInviteModal = false;
      let updatedData = this.getPresenterObjectFromUserModel(data);
      console.log(updatedData);
      this.updatePresenterList(updatedData, data.presenter.id, this.presenterModal.invitationName);
    },
    userModalSubmitEvent(data) {
      data.media_id = this.media_id;
      this.$http.post('/presenters/add-user-as-presenter', data).then( (resp) => {
        this.userModal.showInviteModal = false;
        this.msg_style = (resp.data.status) ? 'alert-primary' : 'alert-danger';
        this.msg = resp.data.msg;
        this.searchedUserExists = true;
        this.media_users = [];
        this.msg_display = 'block';
        this.loadMediaPresenters();
        if (data.user_id == this.$store.getters['user']['user_id']) {
          this.$store.dispatch("reloadUserInfo");
        }
        setTimeout(this.removePresenterAlert, 2000);
      });
    },
    loadMediaPresenters(){
      this.axios
        .get('/networks/media/presenters?media_id='+this.media_id)
        .then((resp) => {
          this.media_presenters = resp.data;
        })
        .catch(err => {
          console.log('err=', err);
          // this.$router.push('/networks'); // back to the homepage
        });
    },
    removeMediaPresenter(user,user_type){
      this.$swal.fire({
        icon: 'warning',
        title: this.$t('are-you-sure-about-this-this-will-remove-the-presenter-from-this-media'),
        showCancelButton: true,
        confirmButtonText : this.$t('yes-remove'),
        customClass: {
          confirmButton: 'btn btn-danger mx-1',
          cancelButton: 'btn btn-primary mx-1',
        },
        buttonsStyling: false
      }).then( (result) => {
        if(result.isConfirmed){
          if(user_type == 'PRESENTER'){
            this.axios
              .post('media/presenter/remove', { 
                  presenter_id : user.pivot.presenter_id, 
                  network_media_id : this.media_id 
                })
              .then( () => {
                  this.loadMediaPresenters();
                })
              .catch(err => {
                console.log('err=', err);
              });
          } else {
            this.media_users.splice(this.media_users.indexOf(user),1);
            this.loadMediaPresenters();
          }
        }
      });
    },
    searchPresenters(searchTerm){
      this.searched_presenters = [];
      if(searchTerm.length > 2){
          this.loading = true;
          this.axios
            .get('networks/presenters?media_id='+this.media_id+'&searchTerm='+searchTerm+'&network_slug='+this.currentNetworkSlug)
            .then( (resp) => {
              if(resp.data.length != 0){
                this.searched_presenters = resp.data;
                this.searchedUserExists = true;
                this.loading = false;
              } else {
                this.searchedUserExists = false;
                this.newPresenterAddedToMedia(searchTerm);
                this.loading = false;
              }
            })
            .catch(err => {
              console.log('err=', err);
              this.loading = false;
            });
        }
      },
      removePresenterAlert() {
        this.msg_display = 'none';
      },
  },
};
</script>